import { createContext, useContext } from 'react';

export interface IConfig {
  gatewayUrl?: string;
  publicUrl?: string;
  apiGateWayURL?: string;
  environment?: string;
}

export const ConfigContext = createContext<IConfig>({
  apiGateWayURL: 'https://api.sravni.ru',
  gatewayUrl: 'http://gateway.svc.master.qa.sravni-team.ru',
  publicUrl: 'http://public.master.qa.sravni-team.ru',
});

export function useConfig<T extends keyof IConfig>(param: T): IConfig[T] {
  return useContext(ConfigContext)[param];
}
